import style from "./style.module.css";
import lectureinfo from "../../../assets/modalIcons/lectureinfo.svg";
import cross from "../../../assets/modalIcons/cross.svg";
import deleteicon from "../../../assets/modalIcons/delete.svg";
import save from "../../../assets/modalIcons/save.svg";
import excel from "../../../assets/modalIcons/excel.svg";
import { useContext, useState } from "react";
import StoreContext from "../../../context/store";
import { deleteSocialClub, editSocialClub } from "../../../api/general";
import {
  successMessage,
  errorMessage,
  warningMessage,
} from "../../../helpers/toast";
import { getTeachers } from "../../../api/general";
import dropdown from "../../../assets/arrowdown.svg";
import useClickOutside from "../../../hooks/useClickOutside";
import { useEffect } from "react";
import { useRef } from "react";

const EditSocialClubModal = ({ socialClubId }) => {
  const { setEditSocialClubClick, socialClub } = useContext(StoreContext);

  const [teacher, setTeacher] = useState(socialClub.ogretmenname);
  const [teacherId, setTeacherId] = useState(socialClub.ogretmenid);
  const [socialClubName, setSocialClubName] = useState(socialClub.klupname);

  // FOR DROPDOWN

  const [optionArea, setOptionArea] = useState(false);
  const buttonRef = useRef(null);

  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    getTeachersMethod();
  }, []); //

  // FOR DROPDOWN

  useClickOutside(buttonRef, () => {
    setOptionArea(false);
  });

  const handleToggle = () => {
    setOptionArea(!optionArea);
  };

  const handleTeacherSelect = (event) => {
    setTeacher(event.target.value.split(",")[0]);
    setTeacherId(event.target.value.split(",")[1]);
    setOptionArea(false);
  };

  const getTeachersMethod = async () => {
    const response = await getTeachers();
    if (response.error) {
      console.log("Test ogretmenler gelmedi");
    } else {
      console.log("Test ogretmenler geldi");
      setTeachers(response.data);
    }
  }; //

  const deleteSocialClubMethod = async () => {
    const response = await deleteSocialClub(socialClubId);
    if (response.error) {
      console.log("Sosyal Kulüp silme başarısız");
      console.log(response.error, "response.erro");
      errorMessage(response.error.response.data.error);
      errorMessage("Sosyal Kulüp silinemedi");
    } else {
      console.log("Sosyal Kulüp silme başarılı");
      successMessage("Sosyal Kulüp silindi");
      setEditSocialClubClick(false);

      setTimeout(function () {
        window.location.reload();
      }, 2500);
    }
  };

  const editSocialClubMethod = async () => {
    if (socialClubName === "" || teacher === "") {
      warningMessage("Lütfen boş alan bırakmayınız");

      return;
    }

    const response = await editSocialClub(
      socialClubName,
      teacherId,
      socialClubId
    );
    if (response.error) {
      console.log("Sosyal Kulüp güncelleme başarısız");
      console.log(response.error, "response.erro");
      errorMessage(response.error.response.data.error);
      errorMessage("Sosyal Kulüp güncellenemedi");
    } else {
      console.log("Sosyal Kulüp güncelleme başarılı");
      successMessage("Sosyal Kulüp güncellendi");
      setEditSocialClubClick(false);

      setTimeout(function () {
        window.location.reload();
      }, 2500);
    }
  };

  return (
    <div className={style.modal}>
      <div className={style.modalbox}>
        <div className={style.uppertabs}>
          <div className={style.tableftside}>
            <div className={style.tab1}>
              <button className={style.tabicon1}>
                <img alt="" src={lectureinfo}></img>
              </button>
              <div className={style.tabtext1}>Sosyal Kulüp Bilgileri</div>
            </div>
          </div>
          <div className={style.tabrightside}>
            <div className={style.tab}>
              <button
                className={style.tabicon}
                onClick={() => {
                  setEditSocialClubClick(false);
                }}
              >
                <img alt="" src={cross}></img>
              </button>
              <div className={style.tabtext}>Kapat</div>
            </div>
          </div>
        </div>
        <div className={style.inputs}>
          <div className={style.input}>
            <div className={style.inputtitle}>Sosyal Kulüp Adı</div>
            <input
              className={style.inputtext}
              value={socialClubName}
              onChange={(e) => setSocialClubName(e.target.value)}
            ></input>
          </div>

          <div className={style.input}>
            <div className={style.inputtitle}>Kulüp Öğretmeni</div>
            <div className={style.dropdown}>
              <div className={style.selectedoption}>{teacher}</div>
              <button onClick={handleToggle}>
                <img src={dropdown} alt=""></img>
              </button>

              {optionArea && (
                <div className={style.optionarea} ref={buttonRef}>
                  <div>
                    {teachers &&
                      teachers.map((teacher, index) => (
                        <button
                          onClick={handleTeacherSelect}
                          value={[teacher.nameSurname, teacher.id]}
                          key={index}
                          className={style.option}
                        >
                          {teacher.nameSurname}
                        </button>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={style.lowertabs}>
          <div className={style.tableftside}>
            <div className={style.tab1}>
              <button
                className={style.tabicon1}
                onClick={() => {
                  deleteSocialClubMethod();
                }}
              >
                <img alt="" src={deleteicon}></img>
              </button>
              <div className={style.tabtext1}>Sil</div>
            </div>
          </div>
          <div className={style.tabrightside}>
            <div className={style.tab}>
              <button
                className={style.tabicon}
                onClick={() => {
                  editSocialClubMethod();
                }}
              >
                <img alt="" src={save}></img>
              </button>
              <div className={style.tabtext}>Kaydet</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSocialClubModal;
